import { render } from "./DiffDernierInventaire.vue?vue&type=template&id=355c8cc4&scoped=true"
import script from "./DiffDernierInventaire.vue?vue&type=script&lang=js"
export * from "./DiffDernierInventaire.vue?vue&type=script&lang=js"

import "./DiffDernierInventaire.vue?vue&type=style&index=0&id=355c8cc4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-355c8cc4"]])

export default __exports__